import { Component, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { zip } from 'rxjs';
import {
  TableColumnConfig,
  TableColumnType,
  TableConfig,
} from 'src/app/modules/shared/components/table-pro/table.config';
import { HostDirective } from 'src/app/modules/shared/directives/host.directive';
import {
  WorkReportStatus,
  WorkReportStatusColorMap,
  WorkReportStatusMap,
} from 'src/app/modules/shared/models/form/work-report-status.enum';
import { JgPhysicalInspUnitDwListRequest } from 'src/app/modules/shared/models/jg/jg-physical-insp-unit-dw-list-request.model';
import { JgPhysicalInspUnitDw } from 'src/app/modules/shared/models/jg/jg-physical-insp-unit-dw.model';
import { JgPhysicalInspUnitFb } from 'src/app/modules/shared/models/jg/jg-physical-insp-unit-fb.model';
import { JgPhysicalInspUnitFxItemSearchRequest } from 'src/app/modules/shared/models/jg/jg-physical-insp-unit-fx-item-search-request.model';
import { JgPhysicalInspUnitFxItem } from 'src/app/modules/shared/models/jg/jg-physical-insp-unit-fx-item.model';
import { ProjectSectionListRequest } from 'src/app/modules/shared/models/project/project-section-list-request.model';
import { ProjectSectionUnitFormType } from 'src/app/modules/shared/models/project/project-section-unit-form-type.enum';
import { ProjectSection } from 'src/app/modules/shared/models/project/project-section.model';
import { OrganizationType } from 'src/app/modules/shared/models/staff/organization-type.enum';
import { NzTreeNode } from 'src/app/modules/shared/models/tree-node.model';
import { GlobalService } from 'src/app/modules/shared/providers/global.service';
import { FileResponse } from 'src/app/modules/shared/providers/request/file-response.model';
import { OrderType } from 'src/app/modules/shared/providers/request/order-type.enum';
import { CommonService } from 'src/app/modules/shared/services/common.service';
import { JgPhysicalInspUnitDwService } from 'src/app/modules/shared/services/jg-physical-insp-unit-dw.service';
import { JgPhysicalInspUnitFbService } from 'src/app/modules/shared/services/jg-physical-insp-unit-fb.service';
import { JgPhysicalInspUnitFxItemService } from 'src/app/modules/shared/services/jg-physical-insp-unit-fx-item.service';
import { ProjectSectionService } from 'src/app/modules/shared/services/project-section.service';

@Component({
  selector: 'app-handover-insp-entity',
  templateUrl: './handover-insp-entity.component.html',
  styleUrls: ['./handover-insp-entity.component.scss'],
})
export class HandoverInspEntityComponent {
  @ViewChild(HostDirective, { static: true }) hiddenHost!: HostDirective;

  config?: TableConfig = new TableConfig();

  mainRequest: JgPhysicalInspUnitFxItemSearchRequest =
    new JgPhysicalInspUnitFxItemSearchRequest();

  searchRequest: JgPhysicalInspUnitFxItemSearchRequest =
    new JgPhysicalInspUnitFxItemSearchRequest();

  pager = this.globalService.recoverPager();

  totalWidth = 0;
  scrollTop = 0;

  recordList: JgPhysicalInspUnitFxItem[] = [];

  cascaderOptions: NzTreeNode[] = [];

  cascaderValue: number[] = [];

  sectionList: ProjectSection[] = [];

  inspUnitDwList: JgPhysicalInspUnitDw[] = [];

  inspUnitFbList: JgPhysicalInspUnitFb[] = [];

  WorkReportStatusMap = WorkReportStatusMap;

  WorkReportStatusColorMap = WorkReportStatusColorMap;

  currentUserType: OrganizationType | undefined =
    this.globalService.userInfo.organizationType;

  OrganizationType = OrganizationType;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private projectSectionService: ProjectSectionService,
    private jgPhysicalInspUnitDwService: JgPhysicalInspUnitDwService,
    private jgPhysicalInspUnitFbService: JgPhysicalInspUnitFbService,
    private jgPhysicalInspUnitFxItemService: JgPhysicalInspUnitFxItemService,
    private globalService: GlobalService,
    private commonService: CommonService,
  ) {}

  getColor(status: string) {
    switch (status) {
      case WorkReportStatus.DRAFT:
        return '#000000';
      case WorkReportStatus.FINISH:
        return '#2b58cd';
      case WorkReportStatus.WAIT_SIGN:
      case WorkReportStatus.WAIT_SEAL:
        return '#A30014';
      case WorkReportStatus.REJECT_SIGN:
      case WorkReportStatus.REJECT_SEAL:
      case WorkReportStatus.CANCLE:
        return '#FF0000';
      default:
        return '#BDC3C7';
    }
  }

  ngOnInit(): void {
    this.getSectionList();
  }

  getSectionList() {
    this.projectSectionService
      .findAll<ProjectSectionListRequest>({
        projectId: this.globalService.projectId,
      })
      .subscribe((projectSections) => {
        this.sectionList = projectSections;
        this.buildSectionTree(projectSections);
      });
  }

  private buildSectionTree(res: ProjectSection[]) {
    const jgSectionIds: number[] = [];
    for (const section of this.globalService.userInfo.projectSections ?? []) {
      if (section.sectionType === OrganizationType.JG_CHECK) {
        jgSectionIds.push(section.sectionId!);
      }
    }
    if (jgSectionIds.length === 0) {
      this.sectionList = [];
      return;
    }
    const cSectionIds: number[] = [];
    if (
      this.globalService.userInfo.organizationType ===
      OrganizationType.CONSTRUCTION
    ) {
      for (const section of this.globalService.userInfo.projectSections ?? []) {
        if (section.sectionType === OrganizationType.CONSTRUCTION) {
          cSectionIds.push(section.sectionId!);
        }
      }
    }
    const jgSections = res.filter((s) => jgSectionIds.includes(s.id!));
    const treeNode: NzTreeNode[] = [];
    for (const section of jgSections) {
      const jgNode = {
        label: section.name!,
        value: section.id!,
        children: [] as NzTreeNode[],
      };
      for (const cSection of section.projectSectionSections ?? []) {
        if (cSection.refSectionType === OrganizationType.CONSTRUCTION) {
          if (
            this.globalService.userInfo.organizationType ===
            OrganizationType.CONSTRUCTION
          ) {
            if (!cSectionIds.includes(cSection.refSectionId!)) {
              continue;
            }
          }
          jgNode.children!.push({
            label: cSection.refSectionName,
            value: cSection.refSectionId!,
            isLeaf: true,
          });
        }
      }
      if (jgNode.children!.length > 0) {
        treeNode.push(jgNode);
      }
    }
    this.cascaderOptions = treeNode;
    if (
      this.cascaderOptions.length > 0 &&
      this.cascaderOptions[0].children!.length > 0
    ) {
      this.cascaderValue = [
        this.cascaderOptions[0].value,
        this.cascaderOptions[0].children![0].value,
      ];
    }
    this.onSectionChange();
  }

  onSectionChange() {
    this.mainRequest.dwCode = '';
    if (this.cascaderValue.length > 0) {
      setTimeout(() => {
        this.getInspUnitDwList();
      }, 50);
    }
  }

  private getInspUnitDwList() {
    zip([
      this.jgPhysicalInspUnitFbService.findAll<JgPhysicalInspUnitFb>({
        projectId: this.globalService.projectId,
        jgSectionId: this.cascaderValue[0],
        sectionId: this.cascaderValue[1],
      }),
      this.jgPhysicalInspUnitDwService.findAll<JgPhysicalInspUnitDwListRequest>(
        {
          projectId: this.globalService.projectId,
          jgSectionId: this.cascaderValue[0],
          sectionId: this.cascaderValue[1],
        },
      ),
    ]).subscribe(([fbList, dwList]) => {
      this.inspUnitFbList = fbList;
      this.inspUnitDwList = dwList;
      this.mainRequest.jgSectionId = this.cascaderValue[0];
      this.mainRequest.sectionId = this.cascaderValue[1];
      this.mainRequest.projectId = this.globalService.projectId;
      this.initConfig();
    });
  }

  @HostListener('window:visibilitychange')
  handleVisibilityChange() {
    this.searchRecord();
  }

  searchRecord() {
    this.jgPhysicalInspUnitFxItemService
      .search<JgPhysicalInspUnitFxItemSearchRequest>(
        this.searchRequest,
        this.pager.pageIndex - 1,
        this.pager.pageSize,
      )
      .subscribe((data) => {
        this.globalService.savePager(this.pager);
        for (const record of data.content) {
          record.hirList = record.jgPhysicalInspUnitForms?.filter(
            (form) => form.formSource === ProjectSectionUnitFormType.JG_HIR,
          );
          record.rfiList = record.jgPhysicalInspUnitForms
            ?.filter(
              (form) => form.formSource === ProjectSectionUnitFormType.JG_RFI,
            )
            .sort((a, b) => +a.formNo! - +b.formNo!);
          for (let i = 0; i < (record.rfiList?.length ?? 0); i++) {
            record.rfiList![i].formDisplayName = record
              .rfiList![i].formNo!.toString()
              .padStart(3, '0');
          }
          for (let i = 0; i < (record.hirList?.length ?? 0); i++) {
            record.hirList![i].formDisplayName = record.hirList![i].formSn;
          }
        }
        this.recordList = data.content;
        this.pager.total = data.totalElements;
      });
  }

  resetSearch() {
    this.searchRequest = JSON.parse(JSON.stringify(this.mainRequest));
    this.searchRequest.dwCodeSortOrder = OrderType.ASC;
    this.pager.pageIndex = 1;
    this.searchRecord();
  }

  queryPanelStateChange(isOpen: boolean) {
    console.log(isOpen);
    if (isOpen === false) {
      this.resetSearch();
    }
  }

  private prepareSearch(data: any) {
    const searchRequest = new JgPhysicalInspUnitFxItemSearchRequest();
    searchRequest.projectId = this.globalService.projectId;
    searchRequest.jgSectionId = this.mainRequest.jgSectionId;
    searchRequest.sectionId = this.mainRequest.sectionId;
    searchRequest.dwCode = this.mainRequest.dwCode;
    Object.assign(searchRequest, data);
    this.searchRequest = searchRequest;
  }

  searchClick(data: any) {
    this.prepareSearch(data);
    this.searchRecord();
  }

  initConfig() {
    const dwOptions = this.inspUnitDwList
      .map((dw) => ({
        label: `${dw.dwCode} ${dw.dwName}`,
        value: dw.dwCode!,
      }))
      .sort((a, b) => {
        return a.value.localeCompare(b.value);
      });

    const uniqueFbMap: string[] = [];
    const fbOptions =
      this.inspUnitFbList
        .filter((fb) => {
          if (uniqueFbMap.includes(fb.jgFbName!)) {
            return false;
          } else {
            uniqueFbMap.push(fb.jgFbName!);
            return true;
          }
        })
        .map((fb) => ({
          label: fb.jgFbName!,
          value: fb.jgFbName!,
        })) ?? [];

    const columns: TableColumnConfig[] = [
      {
        name: '单位工程',
        key: 'dwCode',
        type: TableColumnType.options,
        width: 120,
        queryable: true,
        queryKey: 'dwCode',
        options: dwOptions,
        sortable: true,
        sortKey: 'dwCodeSortOrder',
        sortDefault: OrderType.ASC,
        sortOrder: 1,
      },
      {
        name: '交工分部',
        key: 'jgFbName',
        type: TableColumnType.options,
        width: 80,
        options: fbOptions,
        queryable: true,
        queryKey: 'jgFbName',
      },
      {
        name: '分项工程',
        key: 'jgFxName',
        type: TableColumnType.text,
        width: 120,
        queryable: true,
        queryKey: 'jgFxName',
      },
      {
        name: '检测项目',
        key: 'jgInspItemName',
        type: TableColumnType.text,
        width: 120,
        queryable: true,
        queryKey: 'jgInspItemName',
      },
      {
        group: '分项工程单元数',
        groupWidth: 120,
        name: '交工',
        key: 'appliedUnit',
        type: TableColumnType.text,
        width: 40,
        align: 'right',
      },
      {
        group: '分项工程单元数',
        groupWidth: 120,
        name: '报检',
        key: 'appliedUnit',
        type: TableColumnType.text,
        width: 40,
        align: 'right',
      },
      {
        group: '分项工程单元数',
        groupWidth: 120,
        name: '设计',
        key: 'appliedUnit',
        type: TableColumnType.text,
        width: 40,
        align: 'right',
      },
      {
        name: '交工报检单',
        key: 'questForms',
        type: TableColumnType.text,
        width: 600,
      },
      {
        name: '交工检测报告',
        key: 'reportForms',
        type: TableColumnType.text,
        width: 600,
      },
    ];

    this.config = {
      hasIndex: true,
      columns,
      headerSize: 12,
      bodySize: 13,
    };

    this.totalWidth = columns.reduce((acc, cur) => acc + cur.width, 56);

    this.resetSearch();
  }

  onScroll(e: Event) {
    this.scrollTop = (e.target as HTMLElement).scrollTop;
  }

  onScrollEnd(e: Event) {
    this.scrollTop = (e.target as HTMLElement).scrollTop;
  }

  sign(workFlowKey: string) {
    const query = window.location.href.split('?')[1] ?? '';
    const params = new URLSearchParams(query);
    if (location.href.indexOf('#/open/') > -1) {
      this.openInTab(
        `#/open/custom-form/sign/${workFlowKey!}?token=${params.get('token')}`,
      );
    } else {
      this.openInTab(`#/custom-form/sign/${workFlowKey!}`);
    }
  }

  goQuestSubmit(file: FileResponse) {
    this.globalService.setArchiveReportCache(file);
    const query = window.location.href.split('?')[1] ?? '';
    const params = new URLSearchParams(query);
    const jgSectionId = this.cascaderValue[0];
    const sectionId = this.cascaderValue[1];
    if (location.href.indexOf('#/open/') > -1) {
      this.openInTab(
        `#/open/entity/submit/${jgSectionId}/${sectionId}?token=${params.get('token')}&writeable=${params.get('writeable')}`,
      );
    } else {
      this.openInTab(`#/entity/submit/${jgSectionId}/${sectionId}`);
    }
  }

  goQuestView() {
    const query = window.location.href.split('?')[1] ?? '';
    const params = new URLSearchParams(query);
    if (location.href.indexOf('#/open/') > -1) {
      this.openInTab(
        `#/open/entity/view?token=${params.get('token')}&writeable=${params.get('writeable')}`,
      );
    } else {
      this.openInTab(`#/entity/view`);
    }
  }

  goQuestReport(file: FileResponse) {
    this.globalService.setArchiveReportCache(file);
    const jgSectionId = this.cascaderValue[0];
    const sectionId = this.cascaderValue[1];
    const query = window.location.href.split('?')[1] ?? '';
    const params = new URLSearchParams(query);
    if (location.href.indexOf('#/open/') > -1) {
      this.openInTab(
        `#/open/entity/report/${jgSectionId}/${sectionId}?token=${params.get('token')}&writeable=${params.get('writeable')}`,
      );
    } else {
      this.openInTab(`#/entity/report/${jgSectionId}/${sectionId}`);
    }
  }

  goQuestCheck() {
    const jgSectionId = this.cascaderValue[0];
    const sectionId = this.cascaderValue[1];
    const query = window.location.href.split('?')[1] ?? '';
    const params = new URLSearchParams(query);
    if (location.href.indexOf('#/open/') > -1) {
      this.openInTab(
        `#/open/entity/check/${jgSectionId}/${sectionId}?token=${params.get('token')}&writeable=${params.get('writeable')}`,
      );
    } else {
      this.openInTab(`#/entity/check/${jgSectionId}/${sectionId}`);
    }
  }

  uploadReport(event: any, isReport: boolean) {
    const files: FileList = event.target['files'];
    const file = Array.from(files)[0];
    const convert: boolean[] = [];

    let needConvertToPdf = false;
    const fileName = file.name.toLowerCase();
    if (
      fileName.includes('doc') ||
      fileName.includes('docx') ||
      fileName.includes('xls') ||
      fileName.includes('xlsx') ||
      fileName.includes('ppt') ||
      fileName.includes('pptx')
    ) {
      needConvertToPdf = true;
      convert.push(needConvertToPdf);
    }
    this.commonService
      .uploadFileWithoutProgress(file, needConvertToPdf)
      .subscribe((res: FileResponse) => {
        event.target['value'] = '';
        if (isReport) {
          this.goQuestReport(res);
        } else {
          this.goQuestSubmit(res);
        }
      });
  }

  private openInTab(url: string) {
    const target = window.open(url, '_blank');
    setTimeout(() => {
      target?.postMessage({
        type: 'redir',
        data: window.location.href,
      });
    }, 1000);
    // target?.postMessage('redir', window.location.href);
  }

  pageIndexChange(index: number) {
    this.pager.pageIndex = index;
    this.searchRecord();
  }

  pageSizeChange(size: number) {
    this.pager.pageSize = size;
    this.pager.pageIndex = 1;
    this.searchRecord();
  }
}
